/* Collection sidebar filter typeahead.
   Filters checkbox items in the sibling <ul> as the user types.
   Reveals "see more" hidden items while a query is active so matches in the
   collapsed tail aren't missed; restores hidden state when query is cleared. */
(function () {
  function init() {
    var inputs = document.querySelectorAll('[data-filter-typeahead]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      var wrapper = input.closest('.collection__filter-typeahead');
      if (!wrapper) return;
      var list = wrapper.nextElementSibling;
      while (list && list.tagName !== 'UL') list = list.nextElementSibling;
      if (!list) return;

      var seemore = list.querySelector('.seemore');
      var items = Array.prototype.slice.call(list.querySelectorAll('.collection__filter-checkbox'));

      input.addEventListener('input', function () {
        var q = (input.value || '').trim().toLowerCase();
        var hasQuery = q.length > 0;

        items.forEach(function (li) {
          var label = li.getAttribute('data-filter-label') || '';
          var matches = !hasQuery || label.indexOf(q) !== -1;

          if (hasQuery) {
            // While searching, override the see-more hide state so matches
            // in the collapsed tail are visible. Use the visible class to
            // win the cascade against filter-item--hidden.
            if (matches) {
              li.classList.add('filter-item--visible');
              li.style.display = '';
            } else {
              li.classList.remove('filter-item--visible');
              li.style.display = 'none';
            }
          } else {
            // Restore: clear inline display, drop the override class. Items
            // with data-hidden-default keep their filter-item--hidden class
            // (set by Liquid) so the see-more state is preserved.
            li.style.display = '';
            li.classList.remove('filter-item--visible');
          }
        });

        if (seemore) seemore.style.display = hasQuery ? 'none' : '';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
